import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';
import { Routes } from '../../util/routes';
import { Logo } from './Logo';
import { NavBar } from './NavBar';

export const CompanyHeader = () => {
  const { query } = useRouter();
  const companySlug = query['company-slug'] as string;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileNavigation = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  return (
    <>
      <div className="header sticky top-0 z-40 hidden w-full bg-white p-2 shadow-md md:block md:p-0">
        <div className="mx-auto flex w-full max-w-7xl items-center justify-between p-2">
          <div className="flex space-x-4">
            <Link href={Routes.landingPage(companySlug)} aria-label="logo">
              <Logo organizationSlug={companySlug} />
            </Link>
          </div>

          <NavBar
            productsBarOpen={false}
            openQuoteModal={() => null}
            toggleProductsBar={() => null}
          />
        </div>
      </div>

      {/* mobile nav start */}
      <div
        className={`flex items-center justify-between bg-neutral-200 p-6 md:hidden`}
      >
        <Link href={Routes.landingPage(companySlug)} aria-label="logo">
          <Logo organizationSlug={'harvey-nash'} />
        </Link>

        <button onClick={toggleMobileNavigation}>
          <MenuIcon className="h-8 text-black" />
        </button>
      </div>
      {/* mobile nav end */}

      {/* mobile menu start */}
      {isMobileMenuOpen && (
        <div
          className={`fixed inset-0 z-40 h-screen w-screen space-y-8 overflow-auto bg-neutral-200 p-6 pb-20 backdrop-blur-md backdrop-filter lg:hidden`}
        >
          <div className="flex items-center justify-between">
            <Link href={Routes.landingPage(companySlug)} aria-label="logo">
              <Logo organizationSlug={companySlug} />
            </Link>

            <button onClick={toggleMobileNavigation}>
              <XIcon className="w-8 text-black" />
            </button>
          </div>

          <NavBar
            isMobile={true}
            productsBarOpen={false}
            openQuoteModal={() => null}
            toggleProductsBar={() => null}
            usecasesBarOpen={false}
            toggleUsecasesBar={() => null}
          />
        </div>
      )}
    </>
  );
};
